/* eslint-disable */
import React from "react";
import { Redirect } from "react-router-dom";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// @material-ui/icons
import AddAlert from "@material-ui/icons/AddAlert";
// core components
import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import Button from "components/CustomButtons/Button.jsx";

import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardIcon from "components/Card/CardIcon.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardFooter from "components/Card/CardFooter.jsx";

import httpr from "lib/httpRequest";
import { BASE_URL, AUTH_OPTIONS } from "lib/config";
import { AuthConsumer } from "react-check-auth";

import GetMemberInfo from "actions/MemberAction.jsx";

import CustomTabsWithSubTabs from "components/CustomTabs/CustomTabsWithSubTabs.jsx";
import AddMember from "components/Members/AddMember.jsx";
import EditMember from "components/Members/EditMember.jsx";

import CustomTable from "components/Table/CustomTable.jsx";

import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";

import SnackbarContent from "components/Snackbar/SnackbarContent.jsx";
import Snackbar from "components/Snackbar/Snackbar.jsx";
import Modal from "@material-ui/core/Modal";

const styles = (theme) => ({
  loading: {
    width: "100%",
  },
  dialogControl: {
    width: "100%",
  },
  cardCategoryWhite: {
    "&,& a,& a:hover,& a:focus": {
      color: "rgba(255,255,255,.62)",
      margin: "0",
      fontSize: "14px",
      marginTop: "0",
      marginBottom: "0",
    },
    "& a,& a:hover,& a:focus": {
      color: "#FFFFFF",
    },
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
    "& small": {
      color: "#777",
      fontSize: "65%",
      fontWeight: "400",
      lineHeight: "1",
    },
  },
});

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 28;
const PaperProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

class Members extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      locations: [],
      reports: [],
      tabs: [],
      customTabsCompKey: 0,
      isAdmin: false,
      isService: false,
      addOpen: false,
      editOpen: false,
      deleteOpen: false,
      tl: false,
      tc: false,
      tr: false,
      bl: false,
      bc: false,
      br: false,
      msg: "",
      memberIdToEdit: -1,
      loggedInMemberId: -1,
    };
    this.alertTimeout = null;
  }

  componentDidMount() {
    window.__MUI_USE_NEXT_TYPOGRAPHY_VARIANTS__ = true;
    // fetch organization, location and member info
    this.getOrganizations();
    this.getMemberLocations();
  }

  componentWillUnmount() {
    this.clearAlertTimeout();
  }

  getOrganizations() {
    const token = localStorage.getItem("token");
    const fetch = httpr(token);

    return new Promise(async (resolve, reject) => {
      fetch
        .get(`${BASE_URL}/api/organization`)
        .then((response) => {
          const organizations = response.data;
          const customTabsCompKey = organizations[0].OrganizationId;
          const loggedInMemberId = organizations[0].MemberId;
          const tabs = organizations.map((org) => {
            return {
              tabName: `${org.OrganizationName}`,
              dataUrl: `/api/location/organization/${org.OrganizationId}`,
              organizationId: org.OrganizationId,
              tabContent: <div />,
            };
          });

          this.setState({
            loggedInMemberId: loggedInMemberId,
            customTabsCompKey: customTabsCompKey,
            tabs: tabs,
          });

          if (loggedInMemberId !== null || loggedInMemberId !== undefined) {
            this.getMemberPrivileges(loggedInMemberId);
            this.getMemberReports(loggedInMemberId);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    });
  }

  getMemberPrivileges(memberId) {
    const token = localStorage.getItem("token");
    const fetch = httpr(token);

    return new Promise(async (resolve, reject) => {
      fetch
        .get(`${BASE_URL}/api/members/privileges/${memberId}`)
        .then((response) => {
          const isAdmin = response.data.Admin === 1 ? true : false;
          const isService = response.data.Service === 1 ? true : false;

          if (isAdmin || isService) {
            this.setState({
              isAdmin: isAdmin,
              isService: isService,
            });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    });
  }

  getMemberLocations() {
    const token = localStorage.getItem("token");
    const fetch = httpr(token);

    return new Promise(async (resolve, reject) => {
      fetch
        .get(`${BASE_URL}/api/location`)
        .then((response) => {
          this.setState({ locations: response.data });
        })
        .catch((error) => {
          console.log(error);
        });
    });
  }

  getMemberReports(memberId) {
    const token = localStorage.getItem("token");
    const fetch = httpr(token);

    return new Promise(async (resolve, reject) => {
      fetch
        .get(`${BASE_URL}/api/members/reports/${memberId}`)
        .then((response) => {
          this.setState({ reports: response.data });
        })
        .catch((error) => {
          console.log(error);
        });
    });
  }

  loadMemberInfo() {
    const token = localStorage.getItem("token");
    if (token !== null && token !== undefined) {
      GetMemberInfo(token)
        .then((r) => {
          this.setState({ loading: false, ...r });
        })
        .catch((e) => {
          this.setState({ loading: false });
          console.log(e);
        });
    }
  }

  deleteMember = (mem) => {
    this.setState({
      mem: mem,
      deleteOpen: true,
    });
  };

  confirmDeleteMember = () => {
    const token = localStorage.getItem("token");
    const fetch = httpr(token);

    fetch
      .delete(`${BASE_URL}/api/members/${this.state.mem.MemberId}`)
      .then((response) => {
        this.showNotification(response.data.message);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  handleDeleteClose = () => {
    this.setState({ deleteOpen: false });
  };

  editMember = (memId) => {
    this.setState({
      memberIdToEdit: memId,
      editOpen: true,
    });
  };

  saveMember = (mem) => {
    const token = localStorage.getItem("token");
    const fetch = httpr(token);

    fetch
      .put(`${BASE_URL}/api/members/update`, mem)
      .then((response) => {
        this.showNotification("Saved");
      })
      .catch((error) => {
        console.log(error);
      });
  };

  clearAlertTimeout = () => {
    if (this.alertTimeout !== null) {
      clearTimeout(this.alertTimeout);
    }
  };

  showNotification = (msg) => {
    this.setState({
      tc: true,
      addOpen: false,
      editOpen: false,
      deleteOpen: false,
      msg,
    });
  };

  handleClickOpen = () => {
    this.setState({ addOpen: true });
  };

  handleClose = () => {
    this.setState({ addOpen: false });
  };

  handleEditClickOpen = () => {
    this.setState({ editOpen: true });
  };

  handleEditClose = () => {
    this.setState({ editOpen: false });
  };

  render() {
    const { classes } = this.props;

    return (
      <AuthConsumer>
        {({ isLoading, userInfo, error }) => {
          if (isLoading) {
            return <div />;
          }

          if (!userInfo) {
            return <div />;
          }

          const { member } = userInfo;
          let locationsWithLicenseData = this.state.locations;

          // Add license information to each location - match Reports.jsx pattern
          if (member && member.LocationLicenses && member.LocationLicenses.length > 0) {
            locationsWithLicenseData = this.state.locations.map(location => {
              // Find license data for this location - match DashboardTabs pattern
              const licenseData = member.LocationLicenses.find(
                loc => loc.locationId === location.LocationId
              );
              
              // Add license information to the location object
              return {
                ...location,
                license: licenseData ? licenseData.license : {
                  isValid: 1, // Treat null/missing license as valid
                  daysUntilExpiration: null,
                  expirationDate: null
                }
              };
            });
          } else {
            // If no license data available, treat as valid license
            locationsWithLicenseData = this.state.locations.map(location => ({
              ...location,
              license: {
                isValid: 1, // Treat missing license data as valid
                daysUntilExpiration: null,
                expirationDate: null
              }
            }));
          }

          // Get admin info
          let footerContent;

          // Admin check
          if (this.state.isAdmin === true) {
            footerContent = (
              <Button color="success" onClick={this.handleClickOpen}>
                Create User
              </Button>
            );
          } else {
            footerContent = <div />;
          }

          return (
            <GridContainer>
              <Card>
                <Snackbar
                  place="tc"
                  color="info"
                  icon={AddAlert}
                  message={this.state.msg}
                  open={this.state.tc}
                  closeNotification={() => this.setState({ tc: false })}
                  close
                />
                <GridItem xs={12} sm={12} md={12}>
                  <CustomTabsWithSubTabs
                    key={this.state.key}
                    title="Organizations:"
                    subtitle="Locations:"
                    headerColor="scmain"
                    tabs={this.state.tabs}
                    canSubTabs={true}
                    editMember={this.editMember}
                    deleteMember={this.deleteMember}
                    isAdmin={this.state.isAdmin}
                    memberId={this.state.loggedInMemberId}
                  />
                </GridItem>
                <CardFooter>
                  {footerContent}
                  <Dialog
                    fullWidth={true}
                    maxWidth="md"
                    open={this.state.addOpen}
                    onClose={this.handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    className={classes.dialogControl}
                  >
                    <AddMember
                      showNotification={this.showNotification}
                      handleClose={this.handleClose}
                      isService={this.state.isService}
                      locations={locationsWithLicenseData}
                      reports={this.state.reports}
                    />
                  </Dialog>
                  <Dialog
                    fullWidth={true}
                    maxWidth="md"
                    open={this.state.editOpen}
                    onClose={this.handleEditClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    className={classes.dialogControl}
                  >
                    <EditMember
                      memberId={this.state.memberIdToEdit}
                      isService={this.state.isService}
                      saveMember={this.saveMember}
                      handleEditClose={this.handleEditClose}
                      locations={locationsWithLicenseData}
                      reports={this.state.reports}
                    />
                  </Dialog>

                  <Dialog
                    open={this.state.deleteOpen}
                    onClose={this.handleDeleteClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                  >
                    <DialogTitle id="alert-dialog-title">
                      {"Delete member?"}
                    </DialogTitle>
                    <DialogContent>
                      {this.state.mem && (
                        <DialogContentText id="alert-dialog-description">
                          {this.state.mem.FirstName} {this.state.mem.LastName}
                        </DialogContentText>
                      )}
                    </DialogContent>
                    <DialogActions>
                      <Button onClick={this.handleDeleteClose} color="primary">
                        Cancel
                      </Button>
                      <Button
                        onClick={this.confirmDeleteMember}
                        color="primary"
                        autoFocus
                      >
                        Delete
                      </Button>
                    </DialogActions>
                  </Dialog>
                </CardFooter>{" "}
              </Card>
            </GridContainer>
          );
        }}
      </AuthConsumer>
    );
  }
}

export default withStyles(styles)(Members);



// WEBPACK FOOTER //
// ./src/views/Members/Members.jsx